<template>
  <button
    :id="id"
    type="button"
    :class="buttonClass"
    @click="confirmActive = true"
    :title="title"
  >{{ buttonText }}</button>
  <Modal
    :active="confirmActive"
    @close="confirmActive = false"
  >
    <div class="box content">
      <p>{{ confirmText }}</p>
      <div class="buttons">
        <button
          type="button"
          class="button"
          @click.stop="confirm"
        >{{ confirmButtonText }}</button>
        <button
          type="button"
          class="button"
          @click.stop="confirmActive = false"
        >{{ cancelButtonText }}</button>
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import Modal from "./Modal.vue"
import { defineComponent } from "vue"

/** A button with a Modal afterwards to confirm the action */
export default defineComponent({
  components: {
    Modal
  },
  props: {
    /** HTML ID for the main button */
    id: String,
    /** Shown on the first button */
    buttonText: String,
    /** Shown as text on the modal */
    confirmText: String,
    /** Text on the confirm button */
    confirmButtonText: String,
    /** Text on the cancel button */
    cancelButtonText: String,
    /** CSS class string on the main button */
    buttonClass: String,
    /** Title of the first button */
    title: {
      type: String,
      required: false
    },
  },
  data() {
    return { confirmActive: false }
  },
  emits: ['confirm'],
  methods: {
    confirm() {
      /** The parent should listen to this event instead of to `click` */
      this.$emit("confirm")
      this.confirmActive = false
    }
  }
})
</script>